import { api } from "@/lib/api";

export const workspaceOn = (org) => (org?.module_access || {}).team_workspace === true;
export const isWorkspaceOnly = (user) => !!user?.workspace_only;
export const canManageTeam = (user) =>
  !!user && (user.role === "amden_super_admin" || ["client_admin", "client_manager"].includes(user.role) || !!user.people_admin);
export const canAdminPeople = (user) =>
  !!user && (user.role === "amden_super_admin" || user.role === "client_admin" || !!user.people_admin);
export const isPeopleAdmin = (user) => !!user && (user.role === "amden_super_admin" || !!user.people_admin);

export const LINK_META = {
  priority: { label: "Priority", icon: "Target", key: "priorities" },
  improvement: { label: "Improvement", icon: "Activity", key: "improvements" },
  kpi: { label: "KPI", icon: "Gauge", key: "kpis" },
};

export const PERIOD_STATE = {
  green: { label: "On target", rag: "green" },
  amber: { label: "Near target", rag: "amber" },
  red: { label: "Off target", rag: "red" },
  missing: { label: "Not reported", rag: "red" },
  due: { label: "Due", rag: "blue" },
  unknown: { label: "No target set", rag: "grey" },
  incomplete: { label: "Incomplete", rag: "grey" },
};

export const VERIFY_STATE = {
  unverified: { label: "Awaiting check", rag: "amber" },
  verified: { label: "Verified", rag: "green" },
  queried: { label: "Queried", rag: "red" },
};

export const PROFILE_STATUS = {
  prepared: { label: "Prepared", rag: "grey" },
  invited: { label: "Invited", rag: "blue" },
  active: { label: "Active", rag: "green" },
  left: { label: "Left", rag: "grey" },
};

export const DAYS = [["mon", "Mon"], ["tue", "Tue"], ["wed", "Wed"], ["thu", "Thu"], ["fri", "Fri"], ["sat", "Sat"], ["sun", "Sun"]];
export const WEEKDAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export const CLIENT_ROLE_OPTIONS = [
  ["client_team_member", "Employee (My Workspace only)"],
  ["client_manager", "Manager"],
  ["read_only", "Read-only"],
  ["client_admin", "Administrator"],
];

export const weeklyHours = (wp) => Object.values(wp || {}).reduce((s, v) => s + Number(v || 0), 0);

// Private files are fetched with the session token and handed to the browser as a blob.
export async function openFile(file) {
  const r = await api.get(`/files/${file.id}`, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = file.original_filename || "file";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}

export const fmtSize = (b) => (b == null ? "" : b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);
